"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Suggestion = void 0;
class Suggestion {
    constructor(kind, descriptions, names) {
        this.kind = kind;
        this.descriptions = descriptions;
        this.names = names;
    }
    getDescriptionNames(language) {
        const names = this.descriptions.map((description) => this.getDescriptionName(description.kind, description.type, language));
        return names;
    }
}
exports.Suggestion = Suggestion;
